import React from "react";
import { Modal } from "antd";
import CrmCallHistoryReason from "./CrmCallHistoryReason";
import { useGeneralStore } from "../../../../store/slices/createGeneralSlice";


export default function CrmCallReasonModal({ callHistoryId }) {

    const general = useGeneralStore();
    const visible = general.view.crmCallReasonModal;

    return (
        <div>
            <Modal
                width={800}
                title={"جزییات تماس"}
                className="custom-table crm-request-report"
                visible={visible}
                footer={false}
                onCancel={() => general.ToggleCrmCallReasonModal()} >
                <CrmCallHistoryReason
                    onSubmit={() => {
                        general.ToggleCrmCallReasonModal();
                    }}
                    callHistoryId={callHistoryId}
                />

            </Modal>
        </div>
    );
}
